import {useApolloClient, ApolloClient} from "@apollo/client";
import {HookClass} from "@dvrt/graphql-widgets";
import {MutableRefObject, useEffect, useRef, useState} from "react";
import {
    DomainSettingsQuery,
    DomainSettingsQueryVariables,
    DomainSettingsDocument,
} from "@/components/domain_settings/settings/queries.generated";
import {createInitialData} from "@/components/domain_settings/settings/initialData";

export type Data = {
    settings: DomainSettingsQuery;
};

const initialData: Data = {
    settings: null,
};

export default class DataSource extends HookClass {
    protected client: ApolloClient<object>;
    protected id: number;
    protected setLoaded: (value: boolean) => void;

    public data: MutableRefObject<Data>;
    public loaded: boolean;

    useHooks(id: number) {
        [this.loaded, this.setLoaded] = useState<boolean>(false);
        this.client = useApolloClient();
        this.id = id;
        this.data = useRef<Data>(initialData);

        useEffect(() => {
            this.fetch();
        }, []);
    }

    get initialData() {
        return createInitialData(this.data.current.settings);
    }

    async fetch() {
        this.setLoaded(false);

        const query = await this.client.query<DomainSettingsQuery, DomainSettingsQueryVariables>({
            query: DomainSettingsDocument,
            variables: {
                domainId: this.id,
            },
            fetchPolicy: "no-cache",
        });

        this.data.current.settings = query.data;

        this.setLoaded(true);

        return query.data;
    }
}
